import React from 'react';
import { withStyles, WithStyles, Theme, createStyles } from '@material-ui/core';

import { withIntl, IntlProps } from 'ha/i18n';
import Badge, { Kind } from 'ha/ui/next/Badge';
import units from 'ha/theme/units';
import Button, { ButtonProps } from 'ha/ui/next/Button';
import FilterIcon from 'streamline-icons/filter-1.svg';
import Hidden from 'ha/ui/next/Hidden';
import Grid from 'ha/ui/next/Grid';

interface Props {
  count: number;
  size?: ButtonProps['size'];
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const styles = (theme: Theme) =>
  createStyles({
    label: {
      paddingRight: units.rem(0.5),
    },
    calendarIcon: {
      stroke: theme.palette.primary.main,
      height: '1rem',
      width: '1rem',
      marginRight: '0.5rem',
    },
    badge: {
      marginRight: units.rem(-0.3),
    },
  });

export const OtherFilterButton: React.FC<
  Props & IntlProps & WithStyles<typeof styles>
> = ({ count, size, onClick, classes, intl: { T } }) => {
  const isActive = count > 0;

  return (
    <Button
      variant={isActive ? 'contained' : 'outlined'}
      size={size}
      color="primary"
      data-test-locator="Other Filter Button"
      onClick={onClick}
    >
      <Grid container alignItems="center">
        <Hidden mdUp>
          <FilterIcon className={classes.calendarIcon} />
        </Hidden>
        <Badge
          kind={Kind.inline}
          badgeContent={count}
          classes={{
            badge: classes.badge,
          }}
          showZero
          color={isActive ? 'white' : 'primary'}
        >
          <div className={classes.label}>{T('Filters')}</div>
        </Badge>
      </Grid>
    </Button>
  );
};

OtherFilterButton.displayName = 'OtherFilterButton';

export default withStyles(styles)(withIntl(OtherFilterButton));
